<template>
  <div class="attendance">
    <input type="radio" id="game" name="view" value="game" v-model="view" />
    <label for="one">基準ライン</label>
    <input type="radio" id="weekday" name="view" value="weekday" v-model="view" />
    <label for="two">曜日別</label>

    <div v-if="view === 'game'">
      <input type="checkbox" v-model="hasGames" /><label>節表示</label><br />
          色設定：
      <input type="radio" id="default" name="color" value="default" v-model="color" />
      <label for="default">開催日程</label>
      <input type="radio" id="border" name="color" value="border" v-model="color" />
      <label for="border">基準ライン</label>
      <input type="radio" id="weekday" name="color" value="weekday" v-model="color" />
      <label for="weekday">試合開催曜日着色</label>
      <input type="radio" id="none" name="color" value="none" v-model="color" />
      <label for="none">着色なし</label>
      <br />
      <input type="checkbox" v-model="has1500" /><label>1500人ライン(B ONE仮ライセンス)</label>
      <input type="checkbox" v-model="has1800" /><label>1800人ライン(B ONE開幕後)</label>
      <input type="checkbox" v-model="has2400" /><label>2400人ライン(B ONE開幕前)</label><br />
      <input type="checkbox" v-model="has3000" /><label>3000人ライン(B PREMIERE 3次審査～)</label>
      <input type="checkbox" v-model="has4000" /><label>4000人ライン(B PREMIERE ～2次審査)</label>
      <table class="design01">
        <thead>
          <tr>
            <th rowspan="2">team</th>
            <th rowspan="2" v-for="i in getGames(30)" :key="i">{{ i }}</th>
            <th rowspan="2">平均</th>
            <th rowspan="2">最大</th>
            <th rowspan="2">最小</th>
            <th rowspan="2">合計</th>
            <th rowspan="2">残り試合</th>
            <th colspan="2" v-if="has1500">1500ライン</th>
            <th colspan="2" v-if="has1800">1800ライン</th>
            <th colspan="2" v-if="has2400">2400ライン</th>
            <th colspan="2" v-if="has3000">3000ライン</th>
            <th colspan="2" v-if="has4000">4000ライン</th>
          </tr>
          <tr>
            <th v-if="has1500">残数</th>
            <th v-if="has1500">平均</th>
            <th v-if="has1800">残数</th>
            <th v-if="has1800">平均</th>
            <th v-if="has2400">残数</th>
            <th v-if="has2400">平均</th>
            <th v-if="has3000">残数</th>
            <th v-if="has3000">平均</th>
            <th v-if="has4000">残数</th>
            <th v-if="has4000">平均</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(value) in attendance" :key=value.name>
            <td class="team_name" width="50px">{{ value.name }}</td>
            <td v-for="(game, index) in getGames(value.attendances)" :key="index" width="35px" align="right"
              :class="GetCellStyle(game.weekday, game.type, game.num)">{{ formatNumber(game.num) }}</td>
            <td width="35px" align="right" :class="(color==='none' ? dummy :value.type)" >{{ formatAverage(value.ave) }}</td>
            <td width="35px" align="right">{{ formatNumber(value.max) }}</td>
            <td width="35px" align="right">{{ formatNumber(value.min) }}</td>
            <td width="35px" align="right">{{ formatNumber(value.sum) }}</td>
            <td width="35px" align="right">{{ value.not_held }}</td>
            <td v-if="has1500" width="35px" align="right" :class="GetCellStyleSum(value.ave1500, value.ave)">{{
              value.remain1500 }}</td>
            <td v-if="has1500" width="35px" align="right" :class="GetCellStyleSum(value.ave1500, value.ave)">{{
              value.ave1500 }}</td>
            <td v-if="has1800" width="35px" align="right" :class="GetCellStyleSum(value.ave1800, value.ave)">{{
              value.remain1800 }}</td>
            <td v-if="has1800" width="35px" align="right" :class="GetCellStyleSum(value.ave1800, value.ave)">{{
              value.ave1800 }}</td>
            <td v-if="has2400" width="35px" align="right" :class="GetCellStyleSum(value.ave2400, value.ave)">{{
              value.remain2400 }}</td>
            <td v-if="has2400" width="35px" align="right" :class="GetCellStyleSum(value.ave2400, value.ave)">{{
              value.ave2400 }}</td>
            <td v-if="has3000" width="35px" align="right" :class="GetCellStyleSum(value.ave3000, value.ave)">{{
              value.remain3000 }}</td>
            <td v-if="has3000" width="35px" align="right" :class="GetCellStyleSum(value.ave3000, value.ave)">{{
              value.ave3000 }}</td>
            <td v-if="has4000" width="35px" align="right" :class="GetCellStyleSum(value.ave4000, value.ave)">{{
              value.remain4000 }}</td>
            <td v-if="has4000" width="35px" align="right" :class="GetCellStyleSum(value.ave4000, value.ave)">{{
              value.ave4000 }}</td>
          </tr>

        </tbody>
      </table>

      <table class="legend" v-if="color !== 'none' & hasGames">
        <tr v-if="color === 'weekday'">
          <th>凡例</th>
          <th class="mon">月</th>
          <th class="tue">火</th>
          <th class="wed">水</th>
          <th class="thu">木</th>
          <th class="fri">金</th>
          <th class="sat">土</th>
          <th class="sun">日</th>
        </tr>
        <tr v-else-if="color === 'dafault'">
          <th>凡例</th>
          <th class="schedule">予定</th>
          <th class="exist">終了</th>
          <th class="cancel">キャンセル</th>
          <th class="dummy">なし</th>
        </tr>
        <tr v-else-if="color === 'border'">
          <th>凡例</th>
          <th class="num4000">4000以上</th>
          <th class="num3000">3000以上</th>
          <th class="num2400">2400以上</th>
          <th class="num1800">1800以上</th>
          <th class="num1500">1500以上</th>
          <th class="numuner">1500未満</th>
          <th class="dummy">未開催</th>
        </tr>
        <tr v-if="color === 'weekday'">
          <td>曜日</td>
          <td class="mon">xxx</td>
          <td class="tue">xxx</td>
          <td class="wed">xxx</td>
          <td class="thu">xxx</td>
          <td class="fri">xxx</td>
          <td class="sat">xxx</td>
          <td class="sun">xxx</td>
        </tr>
        <tr v-else-if="color === 'dafault'">
          <td>試合</td>
          <td class="schedule">xxx</td>
          <td class="exist">xxx</td>
          <td class="cancel">xxx</td>
          <td class="dummy">xxx</td>
        </tr>
        <tr v-else-if="color === 'border'">
          <th>人数</th>
          <td class="num4000">xxx</td>
          <td class="num3000">xxx</td>
          <td class="num2400">xxx</td>
          <td class="num1800">xxx</td>
          <td class="num1500">xxx</td>
          <td class="numuner">xxx</td>
          <td class="dummy">xxx</td>
        </tr>
      </table>

      <table class="legend">
        <tr>
          <th>凡例</th>

          <th class="clear">CLEAR</th>
          <th class="std50">～50%</th>
          <th class="std75">75%</th>
          <th class="std100">100%</th>
          <th class="std125">125%</th>
          <th class="std150">150%～</th>
        </tr>
        <tr>
          <td>平均</td>
          <td class="clear">xxx</td>
          <td class="std50">xxx</td>
          <td class="std75">xxx</td>
          <td class="std100">xxx</td>
          <td class="std125">xxx</td>
          <td class="std150">xxx</td>
        </tr>
      </table>
    </div>
    <div v-else>
      色設定：
        <input type="radio" id="border" name="color" value="border" v-model="color2" />
        <label for="border">基準ライン</label>
        <input type="radio" id="none" name="color" value="none" v-model="color2" />
        <label for="none">着色なし</label>
        <br/>
      <input type="radio" id="weekday" value="weekday" v-model="agg" />
      <label for="one">曜日別</label>

      <input type="radio" id="stadium" value="stadium" v-model="agg" />
      <label for="two">曜日・会場別</label>
      <table class="design01">
        <thead>
          <tr>
            <th>チーム</th>
            <th v-if="agg === 'stadium'">会場</th>
            <th>月</th>
            <th>火</th>
            <th>水</th>
            <th>木</th>
            <th>金</th>
            <th>土</th>
            <th>日</th>
            <th v-if="agg === 'stadium'">平均</th>
          </tr>
        </thead>
        <tbody v-if="agg === 'weekday'">
          <tr v-for="(value, key) in weekdayData" :key=key>
            <td class="team_name" width="50px">{{ key }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(value.total.attendance.mon)">{{ formatAverage(value["total"]["attendance"]["mon"]) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(value.total.attendance.tue)">{{ formatAverage(value["total"]["attendance"]["tue"]) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(value.total.attendance.wed)">{{ formatAverage(value["total"]["attendance"]["wed"]) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(value.total.attendance.thu)">{{ formatAverage(value["total"]["attendance"]["thu"]) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(value.total.attendance.fri)">{{ formatAverage(value["total"]["attendance"]["fri"]) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(value.total.attendance.sat)">{{ formatAverage(value["total"]["attendance"]["sat"]) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(value.total.attendance.sun)">{{ formatAverage(value["total"]["attendance"]["sun"]) }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="data in weekdayStadiumData" :key=data.team_name>
            <td class="team_name" width="50px" v-if="data.stadium === '全会場'" :rowspan="data.stadiumCount">{{ data.team_name }}</td>
            <td>{{ data.stadium }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(data.mon)">{{ formatAverage(data.mon) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(data.tue)">{{ formatAverage(data.tue) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(data.wed)">{{ formatAverage(data.wed) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(data.thu)">{{ formatAverage(data.thu) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(data.fri)">{{ formatAverage(data.fri) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(data.sat)">{{ formatAverage(data.sat) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(data.sun)">{{ formatAverage(data.sun) }}</td>
            <td width="100px" align="right" :class="GetCellStyle2(data.ave)">{{ formatAverage(data.ave) }}</td>
          </tr>

        </tbody>
      </table>
      <table class="legend" v-if="color2 !== 'none'">
        <tr>
          <th>凡例</th>
          <th class="num4000">4000以上</th>
          <th class="num3000">3000以上</th>
          <th class="num2400">2400以上</th>
          <th class="num1800">1800以上</th>
          <th class="num1500">1500以上</th>
          <th class="numuner">1500未満</th>
          <th class="dummy">未開催</th>
        </tr>
        <tr>
          <th>人数</th>
          <td class="num4000">xxx</td>
          <td class="num3000">xxx</td>
          <td class="num2400">xxx</td>
          <td class="num1800">xxx</td>
          <td class="num1500">xxx</td>
          <td class="numunder">xxx</td>
          <td class="dummy">xxx</td>
        </tr>
      </table>

    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: 'AttendanceTable',
  props: {
    msg: String,
    season: String,
    league: String
  },
  data() {
    return {
      BASE_URL:"https://datairoro.com/api/v1/attendance/bleague/",
      //BASE_URL: "http://localhost:5000/v1/attendance/bleague/",
      attendance: {},
      responseDate: [],
      weekdayData: {},
      weekdayStadiumData: [],
      has1500: true,
      has1800: true,
      has2400: true,
      has3000: true,
      has4000: true,
      hasGames: false,
      color: "default",
      color2: "border",
      view: "game",
      agg: "weekday",

      games: [],
    }
  },
  watch: {
    season() {
      this.GetData();
    },
    league() {
      this.GetData();
    },
    view() {
      this.GetData();
    }
  },
  mounted() {
    this.has1500 = false;
    this.has1800 = false;
    this.has2400 = false;
    this.has3000 = true;
    this.has4000 = true;
    this.hasGames = false;
    this.color = "default";
    this.GetData();
  },
  methods: {
    calcBorderLineData(base, count, sum, notHeld, cancel) {
      const borderline = base * (count - cancel);
      if (sum >= borderline) {
        return ["CLEAR", "CLEAR"];
      } else {
        if (notHeld < 1) {
          return [this.formatNumber(borderline - sum), "不可能"];
        }
        return [this.formatNumber(borderline - sum), this.formatAverage((borderline - sum) / (notHeld))];
      }
    },
    getGames(games) {
      if (this.hasGames) {
        return games;
      } else {
        return [];
      }
    },
    async GetGamesData() {


      const axiosInstance = axios.create({
        baseURL: this.BASE_URL,
        responseType: 'json',
        withCredentials: true
      });
      const params = {
        season: this.season,
        league: this.league
      }
      try {
        const response = await axiosInstance.post("/season/", params);
        const responseDate = response.data;

        switch (this.league) {
          case "B1":
            this.has1500 = false;
            this.has1800 = false;
            this.has2400 = false;
            this.has3000 = true;
            this.has4000 = true;
            this.hasGames = false;
            this.color = "default";
            break;
          case "B2":
            this.has1500 = true;
            this.has1800 = false;
            this.has2400 = true;
            this.has3000 = true;
            this.has4000 = false;
            this.hasGames = false;
            this.color = "default";
            break;
          case "B3":
            this.has1500 = true;
            this.has1800 = false;
            this.has2400 = true;
            this.has3000 = true;
            this.has4000 = false;
            this.hasGames = false;
            this.color = "default";
            break;
          default:
            this.has1500 = true;
            this.has1800 = false;
            this.has2400 = true;
            this.has3000 = true;
            this.has4000 = false;
            this.hasGames = false;
            this.color = "default";
            break;
        }

        this.createViewData(responseDate);
      } catch (e) {
        console.log(e);
      }
    },
    async GetWeekdayData() {
      const axiosInstance = axios.create({
        baseURL: this.BASE_URL,
        responseType: 'json',
        withCredentials: true
      });
      const params = {
        season: this.season,
        league: this.league
      }
      try {
        const w_response = await axiosInstance.post("/season/weekday/", params);
        const weekdayData = w_response.data;

        const stadium_response = await axiosInstance.post("/season/weekday/stadium/", params);
        const stadiumData = stadium_response.data;

        this.createWeekdayData(weekdayData, stadiumData);
      } catch (e) {
        console.log(e);
      }
    },
    async GetData() {
      switch (this.view) {
        case "weekday":
          this.GetWeekdayData();
          break;
        default:
          this.GetGamesData();
          break;
      }
    },
    createViewData(responseDate) {
      let tmp = {};
      for (const game of responseDate) {
        let num = game.attendance
        if (!(game.team_name in tmp)) {
          if (num <= 0) {
            tmp[game.team_name] = {
              attendances: [],
              max: 0,
              min: 100000,
              sum: 0,
              ave: 0,
              cancel: 0,
              cnt: 1,
              held: 0,
              name: game.team_name
            }

          } else {
            tmp[game.team_name] = {
              attendances: [],
              max: num,
              min: num,
              sum: num,
              cancel: 0,
              ave: 0,
              cnt: 1,
              held: 1,
              name: game.team_name
            }
          }
          if (game.is_cancel === 1) {
            tmp[game.team_name].cancel += 1;
          }

        } else {


          if (game.is_cancel === 1) {
            tmp[game.team_name].cancel += 1;
          } else {
            if (num >= 0) {
              tmp[game.team_name].held += 1;
              tmp[game.team_name].sum += num;
              if (num > tmp[game.team_name].max) {
                tmp[game.team_name].max = num
              } else if (num < tmp[game.team_name].min) {
                tmp[game.team_name].min = num;
              }
            }
          }
          tmp[game.team_name].cnt += 1;

        }
        let weekday = ""
        switch (game.weekday) {
          case 1:
            weekday = "sun";
            break;
          case 2:
            weekday = "mon";
            break;
          case 3:
            weekday = "tue";
            break;
          case 4:
            weekday = "wed";
            break;
          case 5:
            weekday = "thu";
            break;
          case 6:
            weekday = "fri";
            break;
          case 7:
            weekday = "sat";
            break;
        }

        if (num > 0) {
          tmp[game.team_name].attendances.push({
            num: num,
            date: game.date,
            arena: game.stadium,
            weekday: weekday,
            type: "exist"
          })
        } else {
          if (game.is_cancel === 1) {
            tmp[game.team_name].attendances.push({
              num: "-",
              date: game.date,
              arena: game.stadium,
              weekday: weekday,
              type: "cancel"
            })
          } else {
            tmp[game.team_name].attendances.push({
              num: "-",
              date: game.date,
              arena: game.stadium,
              weekday: weekday,
              type: "schedule"
            })
          }
        }
      }

      // ave計算
      for (let data of Object.values(tmp)) {
        const l = data.attendances.length;
        data.ave = data.sum / data.held;
        data.not_held = data.cnt - data.held - data.cancel;

        // 計算
        // 1500
        let [remain, ave] = this.calcBorderLineData(1500, data.cnt, data.sum, data.not_held, data.cancel);
        data.remain1500 = remain;
        data.ave1500 = ave;
        // 1800
        [remain, ave] = this.calcBorderLineData(1800, data.cnt, data.sum, data.not_held, data.cancel);
        data.remain1800 = remain;
        data.ave1800 = ave;
        // 2400
        [remain, ave] = this.calcBorderLineData(2400, data.cnt, data.sum, data.not_held, data.cancel);
        data.remain2400 = remain;
        data.ave2400 = ave;
        // 3000
        [remain, ave] = this.calcBorderLineData(3000, data.cnt, data.sum, data.not_held, data.cancel);
        data.remain3000 = remain;
        data.ave3000 = ave;
        // 4000
        [remain, ave] = this.calcBorderLineData(4000, data.cnt, data.sum, data.not_held, data.cancel);
        data.remain4000 = remain;
        data.ave4000 = ave;

        // type
        if (data.ave >= 4000) {
          data.type = "num4000"
        } else if (data.ave >= 3000) {
          data.type = "num3000"
        } else if (data.ave >= 2400) {
          data.type = "num2400"
        } else if (data.ave >= 1800) {
          data.type = "num1800"
        } else if (data.ave >= 1500) {
          data.type = "num1500"
        }else{
          data.type = "numunder"
        }

        // 30までたす
        for (let i = l; i < 30; i++) {
          data.attendances.push({
            num: "-",
            type: "dummy",
          })
        }
      }

      // 並び替え
      this.attendance = Object.keys(tmp).map(function (key) {
        return tmp[key];
        //②dateでソート
      }).sort(function (a, b) {
        return (a.ave > b.ave) ? -1 : 1;  //オブジェクトの昇順ソート
      });
      console.log(this.attendance)
    },
    createWeekdayData(weekday, stadiumData) {
      let tmp = {};
      for (const game of weekday) {
        const team_name = game.team_name;
        if (!(team_name in tmp)) {
          tmp[team_name] = {
            total: {
              cnt: {
                mon: 0,
                tue: 0,
                wed: 0,
                thu: 0,
                fri: 0,
                sat: 0,
                sun: 0,
              },
              attendance: {
                mon: "-",
                tue: "-",
                wed: "-",
                thu: "-",
                fri: "-",
                sat: "-",
                sun: "-"
              }
            }
          }
        }
        let weekday = ""
        switch (game.weekday) {
          case 1:
            weekday = "sun";
            break;
          case 2:
            weekday = "mon";
            break;
          case 3:
            weekday = "tue";
            break;
          case 4:
            weekday = "wed";
            break;
          case 5:
            weekday = "thu";
            break;
          case 6:
            weekday = "fri";
            break;
          case 7:
            weekday = "sat";
            break;
        }
        tmp[team_name].total["attendance"][weekday] = Number(game.avg);
        tmp[team_name].total["cnt"][weekday] = Number(game.cnt);
      }

      //stadium
      for (const game of stadiumData) {
        const team_name = game.team_name;
        const stadium = game.stadium;
        if (!(stadium in tmp[team_name])) {
          tmp[team_name][stadium] = {
            cnt: {
              mon: 0,
              tue: 0,
              wed: 0,
              thu: 0,
              fri: 0,
              sat: 0,
              sun: 0,
            },
            attendance: {
              mon: "-",
              tue: "-",
              wed: "-",
              thu: "-",
              fri: "-",
              sat: "-",
              sun: "-"
            }
          }
        }
        let weekday = ""
        switch (game.weekday) {
          case 1:
            weekday = "sun";
            break;
          case 2:
            weekday = "mon";
            break;
          case 3:
            weekday = "tue";
            break;
          case 4:
            weekday = "wed";
            break;
          case 5:
            weekday = "thu";
            break;
          case 6:
            weekday = "fri";
            break;
          case 7:
            weekday = "sat";
            break;
        }
        tmp[team_name][stadium]["attendance"][weekday] = Number(game.avg);
        tmp[team_name][stadium]["cnt"][weekday] = Number(game.cnt);
      }

      this.weekdayData = tmp;

      let stdData = [];
      for (const team in tmp) {
        const key = "total"
        let cnt = 0;
        let sum = 0;

        for (const weekday of Object.keys(tmp[team][key]["attendance"])) {
          if (tmp[team][key]["attendance"][weekday] !== "-") {
            cnt += tmp[team][key]["cnt"][weekday];
            sum += tmp[team][key]["attendance"][weekday]* tmp[team][key]["cnt"][weekday];
          }
        }
        const ave = sum / cnt;
        stdData.push({
          team_name: team,
          stadium: "全会場",
          stadiumCount: Object.keys(tmp[team]).length,
          mon: tmp[team][key]["attendance"].mon,
          tue: tmp[team][key]["attendance"].tue,
          wed: tmp[team][key]["attendance"].wed,
          thu: tmp[team][key]["attendance"].thu,
          fri: tmp[team][key]["attendance"].fri,
          sat: tmp[team][key]["attendance"].sat,
          sun: tmp[team][key]["attendance"].sun,
          ave: ave,
        })
        for (const key in tmp[team]) {
          if (key !== "total") {
            let cnt = 0;
            let sum = 0;
            for (const weekday of Object.keys(tmp[team][key]["attendance"])) {
              if (tmp[team][key]["attendance"][weekday] !== "-") {
                cnt += tmp[team][key]["cnt"][weekday];
                sum += tmp[team][key]["attendance"][weekday] * tmp[team][key]["cnt"][weekday];
              }
            }
            const ave = sum / cnt;

          
            stdData.push({
              team_name: team,
              stadium: key,
              
              mon: tmp[team][key]["attendance"].mon,
              tue: tmp[team][key]["attendance"].tue,
              wed: tmp[team][key]["attendance"].wed,
              thu: tmp[team][key]["attendance"].thu,
              fri: tmp[team][key]["attendance"].fri,
              sat: tmp[team][key]["attendance"].sat,
              sun: tmp[team][key]["attendance"].sun,
              ave: ave,
            })
          }
        }
        
      }
    
    this.weekdayStadiumData = stdData;
  },
  formatNumber(value) {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  },
  formatAverage(value) {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  },
  GetCellStyle(weekday, type, value) {
    switch (this.color) {
      case "none":
        return "none";
      case "weekday":
        return weekday;
      case "border":
        if(value === "-"){
          return "none"
        }else if(value >= 4000){
          return "num4000";
        }else if(value >= 3000){
          return "num3000";
        }else if(value >= 2400){
          return "num2400";
        }else if(value >= 1800){
          return "num1800";
        }else if(value >= 1500){
          return "num1500";
        }else{
          return "numunder";
        }
      default:
        return type;
    }
  },
  GetCellStyle2(value){
    switch (this.color2) {
      case "none":
        return "none";
      default:
        if(value === "-"){
          return "none"
        }else if(value >= 4000){
          return "num4000";
        }else if(value >= 3000){
          return "num3000";
        }else if(value >= 2400){
          return "num2400";
        }else if(value >= 1800){
          return "num1800";
        }else if(value >= 1500){
          return "num1500";
        }else{
          return "numunder";
        }

    }
  },
  GetCellStyleSum(standard, average) {
    if(this.color === "none"){
      return "none"
    }

    if (standard === "CLEAR") {
      return "clear"
    }

    const std = Number(standard.replace(/,/, ''));
    const ave = Number(average);

    if (ave * 0.5 > std) {
      return "std50";
    } else if (ave * 0.75 > std) {
      return "std75";
    } else if (ave > std) {
      return "std100";
    } else if (ave * 1.25 > std) {
      return "std125"
    } else {
      return "std150"
    }

  }
},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.design01 {
  font-size: 75%;
  text-align: center;
  border-collapse: collapse;
  border-spacing: 0;
  margin: auto;
}

.design01 th {
  background: #e9faf9;
  border: solid 1px #778ca3;
}

.design01 td {
  border: solid 1px #778ca3;
}

.legend {
  font-size: 75%;
  text-align: center;
  border-collapse: collapse;
  border-spacing: 0;
  margin: auto;
}

.legend th {
  background: #e9faf9;
  border: solid 1px #778ca3;
}

.legend td {
  border: solid 1px #778ca3;
}


td.sun {
  background-color: #ffb6c1;
}

td.mon {
  background-color: #2bd580;
}

td.tue {
  background-color: #dc143c;
  color: white
}

td.wed {
  background-color: #4169e1;
  color: white;
}

td.thu {
  background-color: green;
  color: white;
}

td.fri {
  background-color: yellow
}

td.sat {
  background-color: #87ceeb;
}

td.schedule {
  background-color: #72e2aa;
}

td.dummy {
  background-color: gray;
}

td.cancel {
  background-color: gray;
}

td.none {
  background-color: white;
}

td.clear {
  background-color: #4169e1;
  color: white;
}

td.std50 {
  background-color: #2bd580;
}

td.std75 {
  background-color: #72e2aa;

}

td.std100 {
  background-color: #b1efd0;
}

td.std125 {
  background-color: yellow
}

td.std150 {
  background-color: #dc143c;
  color: white
}

td.num4000{
  background-color: #ff55aa;
}
td.num3000{
  background-color: #ffaad5;
}

td.num2400{
  background-color: #2bd580;

}

td.num1800{
  background-color: #72e2aa;
}

td.num1500{
  background-color: #b8f1d5;
}

td.numunder{
  background-color: brown;
  color: white
}


</style>

